import React, { useState } from 'react';

import { AbaFilterButtons, AbaFilterContent } from '../../../../components/develop-nilton-components/AbaFiltro';
import { FatoresIntAnual } from './FatoresIntAnual';
import { FatoresIntTrimestral } from './FatoresIntTrimestral';

export function FatoresInt({ tabType }:{tabType:number}) {
  const [tab, setTab] = useState(1);
  return (
    <div className="mt-3">
      <AbaFilterButtons
        useStateTab={[tab, setTab]}
        buttons={["Anual", "Trimestral"]}
      />
      <AbaFilterContent
        tab={tab}
        components={[
          <FatoresIntAnual tab={tab} tabType={tabType} />,
          <FatoresIntTrimestral tab={tab} tabType={tabType} />,
        ]}
      />
    </div>
  );
}
